import Api from 'src/api/Base'

class PostExportStores extends Api {
  requestUrl = '/api/Export/Stores'

  method = 'POST'
}

export default PostExportStores
